module.exports = __webpack_public_path__ + "images/bannerEN-5ee7c85292e91b93d616179802180938.jpg";